// router.js
import { createRouter, createWebHistory } from 'vue-router';
import ShiftKiosk from './components/ShiftKiosk.vue';
import HomePage from './components/HomePage.vue';
import LoginPage from './components/LoginPage.vue';

const routes = [
  {
    path: '/kiosk',
    name: 'Kiosk',
    component: ShiftKiosk,
    meta: { requiresAuth: true }
  },
  {
    path: '/',
    name: 'HomePage',
    component: HomePage,
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginPage,
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;